import ApiRoutes from "../constants/ApiRoutes";
import ApiClient from "../utilities/api-client";
import ErrorUtils from "../utilities/error-utils";
import AuthenticationService from "./authentication-service";
import CartService from "./cart-service";

const ProductService = {
    items : [],
    locations: [],
    /** -----------------------------------------------------
     * Method : getItems
     * Description : Method to get items from a vendor
     * @returns items
     */
    getItems : async (locationId) => {
        let items;
        try{
            const url = `${ApiRoutes.EMPLOYEE.ROOT_CONTEXT}${ApiRoutes.EMPLOYEE.ITEMS}?${ApiRoutes.EMPLOYEE.CURRENT_LOCATION_ID}=${locationId}`;
            const response = await ApiClient.get(url);
            items = response?.data?.items || undefined;
            const balance = response?.data?.currentBalance;
            AuthenticationService.setUserBalance(balance);
            const { items : cartItems } = CartService.getCart();
            if(items && cartItems) {
                // To set quantity if the items are already available in cart
                // To Do : Seems like costly operation. Need to optimize later
                items.forEach(item => {
                    const cartItem = cartItems.filter(i => item.id === i.id);
                    item.quantity = cartItem.length > 0 ? cartItem[0].quantity : 0;
                })
            }
            ProductService.items = items;
            return items;
        } catch(e) {
            throw ErrorUtils.processError(e);
        }
        
    },

    /**-----------------------------------------------------
     * Method : searchItems
     * Description : Search items by name
     * @param {*} searchText 
     * @returns 
     */
    searchItems : async (searchText) => {
        const searchedItems = ProductService.items.filter((item) => {
            if(item.name.toLowerCase().includes(searchText.toLowerCase())) {
                return item;
            }
        })
        return searchedItems;
    },

    getLocations: async () => {
        let locations;
        try{
            const url = `${ApiRoutes.EMPLOYEE.ROOT_CONTEXT}${ApiRoutes.EMPLOYEE.LOCATIONS}`;
            const response = await ApiClient.get(url);
            locations = response?.data?.locations || undefined;
            ProductService.locations = locations;
            return locations;
        } catch(e) {
            throw ErrorUtils.processError(e);
        }
    }
}

export default ProductService;